import { useEffect, useState } from 'react';
import { DropdownOption } from '../../components/Dropdown/interfaces';
import { getUsersDropdown } from '../api';


export default function useUsersDopdown(isAdmin: boolean) {
  const [options, setOptions] = useState<DropdownOption[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchOptions = async () => {
    const usersOptions = await getUsersDropdown({}, isAdmin, setLoading);
    setOptions([
      {
        id: null,
        label: 'All',
        value: '',
      },
      ...usersOptions,
    ]);
  };

  useEffect(() => {
    fetchOptions();
  }, [isAdmin]);

  return {
    options,
    loading,
  };
}
